export default "__VITE_ASSET__BjsrlwH7__"